<template>
  <div class="main-content col-lg-12">
    <h2>
      <strong>Swappie 隐私声明</strong>
    </h2>
    <p>
      <span
        >欢迎阅读我们的隐私声明。我们在此告知您，我们收集您的哪些类型的个人数据、我们如何使用这些数据以及您作为数据主体的权利。如果您符合以下情况，本隐私声明适用于您：</span
      >
    </p>
    <ul>
      <li aria-level="1">
        <span>我们的客户或潜在客户</span>
      </li>
      <li aria-level="1">
        <span>我们网站的访客</span>
      </li>
      <li aria-level="1">
        <span>我们的企业客户或业务合作伙伴的代表或联系人</span>
      </li>
    </ul>
    <p class="p1"></p>
    <p>
      <span
        >Swappie Oy（"我们"或"Swappie"）是本隐私声明中所述数据的数据控制者。请注意，如果 Swappie
        为其企业客户或合作伙伴充当数据处理者，您应查阅这些方的隐私声明，以获取有关您个人数据收集和处理的信息。&nbsp;</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >另请注意，Swappie
        网站可能包含指向其他网站的链接。我们的隐私声明仅适用于我们的网站，因此，如果您点击指向其他网站的链接，您应该熟悉其隐私声明。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >为了让您更轻松地找到所需的信息，我们将提供的信息分为以下主题，希望可以帮助您浏览本通知：</span
      >
    </p>
    <ul>
      <li aria-level="1">
        <b>收集哪些数据以及用于什么目的？</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>曲奇饼</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>营销&nbsp;</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>数据披露</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>我们会存储您的数据多久？我们如何保护它？</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>您的数据保护权利是什么？</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>隐私政策的变更</b>
      </li>
    </ul>
    <ul>
      <li aria-level="1">
        <b>联系信息</b>
      </li>
    </ul>
    <h4>
      <b>收集哪些数据以及用于什么目的？</b>
    </h4>
    <p>
      <span
        >本节解释了 Swappie
        收集您的哪些个人数据、收集目的、收集方式以及收集这些数据的法律依据。请注意，以下多个类别可能适用于您（例如，如果您是我们的客户并使用我们的网站，则应阅读所有相关章节）。</span
      >
    </p>
    <p class="p1"></p>
    <p><b>如果您是 Swappie 客户</b><span>，我们会收集您的以下信息：&nbsp;</span></p>
    <ul>
      <li aria-level="1">
        <span>姓名</span>
      </li>
      <li aria-level="1">
        <span>联系信息</span>
      </li>
      <li aria-level="1">
        <span>如果您将设备卖给我们，请提供您的银行信息</span>
      </li>
      <li aria-level="1">
        <span>其他交易详细信息，例如产品类型</span>
      </li>
      <li aria-level="1">
        <span>您的付款详情</span>
      </li>
      <li aria-level="1">
        <span>您可能与我们进行的沟通</span>
      </li>
    </ul>
    <p>
      <span
        >您在与我们进行交易时（例如，填写我们的在线表格或以任何其他方式与我们沟通）会提供此类信息。我们将使用这些信息来处理您的交易、提供客户服务、就您的交易与您沟通，以及管理您的客户账户。我们也可能在法律要求的范围内使用这些数据向您进行营销，您可以随时选择退订营销信息。此外，我们可能会进行客户调查，利用上述数据与您联系，并收集有关您的客户体验、偏好和其他反馈的更多信息。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >请注意，当您在我们的网站上付款或订阅付费订阅时，您的交易和付款详情将发送给提供支付功能的支付服务合作伙伴。我们还会与物流合作伙伴共享您的订单详情，以便将订单配送给您，或安排取货。如果您选择延期付款并申请信用，我们的支付服务提供商可能会进行信用审查，以确保您的信用状况。有关其数据处理活动的更多信息，请参阅相关合作伙伴的隐私声明。&nbsp;</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >收集和处理上述数据的法律依据是履行您与我们之间的合同，以及在用于营销或客户调查目的的范围内，我们向您宣传我们的产品和服务并发展业务的合法权益。如果您因与我们的交易而订阅我们的时事通讯，则处理您数据的法律依据是您的同意，您可以通过取消订阅我们的时事通讯来撤销您的同意。有关我们营销实践的更多信息，请参阅"营销"部分。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >如果我们承担法律义务，或出于合法利益开展防欺诈活动之必要，我们还可能收集您的其他身份信息，例如您的身份证件或身份证号码的复印件。此外，我们和我们的支付服务合作伙伴可能会使用防欺诈技术，以确保我们与您进行合法交易，并阻止潜在的购买企图，例如使用被盗身份或支付信息。我们这样做是基于我们防止业务中出现欺诈和犯罪行为的合法利益，并且从您那里收集的数据可能会与公共信息或数据库进行交叉引用，以推断您具体情况的欺诈风险等级。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <b>如果您同意我们的营销或向我们提交您的数据：</b
      ><span
        >如果您同意我们的营销（例如，订阅我们的时事通讯），我们会收集您的联系方式和有关您的同意状态的信息。收集和处理这些数据的法律依据是您的同意，并用于向您提供我们的营销信息。您可以随时按照营销信息中的说明或联系我们选择退出。我们有时还会举办不同类型的活动或比赛，您可能会向我们提供您的联系方式以及其他与您参与活动相关的潜在活动信息。收集和处理这些数据的法律依据是与活动相关的合同的签订和履行，这些数据用于开展活动或比赛活动以及就您的参与事宜与您联系。&nbsp;</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <b>当您访问我们的网站时，</b
      ><span
        >您的设备会自动向我们发送某些技术信息和其他信息（例如 IP
        地址、浏览器和设备详细信息以及您的访问来源）。这些信息用于向您提供网站及其包含的服务，其法律依据是我们的合法利益或您与我们之间合同的签订和履行（视具体情况而定）。我们还可能通过使用
        Cookie 收集有关您使用网站的信息。有关通过 Cookie
        和类似技术收集的数据的信息，请参阅下文"Cookie"部分。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <b>如果您是我们企业客户或业务合作伙伴的代表或联系人，或与我们合作的个体企业家</b
      ><span>，我们会收集您的以下信息：</span>
    </p>
    <ul>
      <li aria-level="1">
        <span
          >姓名和联系方式，如果您是独资经营者，则需要提供详细信息以识别您是我们合同伙伴的身份。</span
        >
      </li>
      <li aria-level="1">
        <span>您与我们的客户/业务伙伴的关系的职位和其他信息</span>
      </li>
      <li aria-level="1">
        <span>有关我们互动和您的偏好的可能详细信息</span>
      </li>
    </ul>
    <p>
      <span
        >您在联系我们时直接提供这些信息，如果您并非事先直接联系我们，我们会从您的组织和其他与我们沟通的代表处获取数据。我们使用这些信息来管理我们与企业客户/业务合作伙伴的关系、执行合同，并进行相关沟通。数据处理的法律依据是我们管理合同关系、与客户或业务合作伙伴合作的合法权益；如果您是自然人，且是我们的合同相对方，则我们之间协议的执行也基于此。&nbsp;</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >如果我们需要向税务机关报告与我们合作相关的交易，我们可能还需要收集您的个人税务识别号。收集和处理此类数据的依据是遵守我们所承担的法律义务。</span
      >
    </p>
    <h4><b>&nbsp;</b><b>曲奇饼&nbsp;</b></h4>
    <p>
      <span
        >Cookie 是网站在您访问时存储在您的浏览器或设备上的数据。启用 Cookie
        后，它们会通过您的设备和浏览器收集您的某些个人数据。我们使用的 Cookie
        可能会收集以下信息：</span
      >
    </p>
    <ul>
      <li aria-level="1">
        <span>IP 地址</span>
      </li>
      <li aria-level="1">
        <span>浏览器类型、版本和会话标识符</span>
      </li>
      <li aria-level="1">
        <span>设备类型和操作系统</span>
      </li>
      <li aria-level="1">
        <span>网站 URL 跟踪、花费的时间以及网站上的操作</span>
      </li>
      <li aria-level="1">
        <span>访问时间和城市位置</span>
      </li>
    </ul>
    <p class="p1"></p>
    <p>
      <span
        >上述信息收集的范围取决于您激活的 Cookie 类型。您可以通过访问我们网站时显示的 Cookie
        横幅，选择禁用对我们网站运行并非绝对必要的 Cookie。您也可以随时通过浏览器设置删除已安装的
        Cookie。&nbsp;</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span>我们将 Cookie 用于以下目的：</span>
    </p>
    <ul>
      <li aria-level="1">
        <span>确保我们网站的正常运行（"绝对必要的 Cookie"）</span>
      </li>
      <li aria-level="1">
        <span>在我们的网站上提供更多功能和个性化（"功能性 cookie"）</span>
      </li>
      <li aria-level="1">
        <span>为您提供个性化广告（"广告 cookies"）</span>
      </li>
      <li aria-level="1">
        <span>测量、分析和改进我们网站的性能（"性能 cookie"）&nbsp;</span>
      </li>
    </ul>
    <p class="p1"></p>
    <p>
      <span>通过 cookie 收集个人数据的法律依据是：对于严格必要的 cookie，我们的合法利益，</span
      ><span>或根据具体情况您与我们之间签订和履行的合同；</span
      ><span
        >对于所有其他 cookie，您通过点击"接受"我们 cookie 横幅中选择的 cookie
        而给予我们的同意（如果您选择）。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span>有关我们网站当前使用的 cookie 的更多详细信息，请参阅本页底部的 cookie 列表。</span>
    </p>
    <h4>
      <b>营销</b>
    </h4>
    <p>
      <span
        >如前所述，我们可能会使用您的部分个人数据来向您投放广告。在本节中，我们将向您详细介绍我们的营销活动和实践。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >如果您已同意我们向您发送营销信息（例如通过订阅我们的新闻通讯），或者我们基于合法利益有权与您联系，我们可能会向您发送有关我们产品和服务、优惠和活动，或有关
        Swappie
        活动或其合作伙伴的其他相关新闻的通讯和广告。我们可能会根据您提供的联系方式，通过电子邮件或短信向您发送这些信息。如上所述，您始终有权按照每条营销通讯或消息中提供的退订说明，选择退订这些信息。您也可以使用以下联系方式联系我们，选择退订。&nbsp;</span
      >
    </p>
    <h4>
      <b>数据披露</b>
    </h4>
    <p>
      <span
        >我们出于上述目的在 Swappie
        集团公司内部共享个人数据。此外，为了实现本通知中描述的某些目的，我们可能会与我们的服务提供商或业务合作伙伴共享您的部分个人数据，例如为我们提供服务或代表我们采取行动以提供服务或促成与您交易的各方，例如我们的物流和支付服务合作伙伴、我们的
        IT
        服务提供商、顾问，或通过我们的合作参与您的客户旅程的合作伙伴（例如，我们的交易所或配送合作伙伴）。如果您同意第三方
        Cookie，或订阅了我们的新闻通讯或营销活动，我们可能会与这些第三方 Cookie
        提供商以及为我们执行处理目的的营销合作伙伴共享您的个人数据。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span>如果发生以下情况，我们还可能向 Swappie 以外的第三方披露个人数据：</span>
    </p>
    <ul>
      <li aria-level="1">
        <span>这是法律要求的，例如，如果我们需要披露个人数据以响应公共当局或执法机构的请求。</span>
      </li>
      <li aria-level="1">
        <span
          >披露您的个人数据对于确保
          Swappie、我们的合作伙伴、我们的客户或您的安全和保护其权利是必要的，或者为了根据法律实现公共利益的目的。</span
        >
      </li>
      <li aria-level="1">
        <span
          >如果我们参与合并、收购或以任何形式出售我们的全部或部分资产，我们可能会在评估和达成此类交易的过程中共享和/或转移您的个人数据。</span
        >
      </li>
      <li aria-level="1">
        <span>在任何其他情况下，我们已获得您对此类转移的同意。</span>
      </li>
    </ul>
    <p class="p1"></p>
    <p>
      <span
        >由于我们的部分服务提供商和合作伙伴位于欧洲经济区以外，我们可能需要将个人数据转移至欧洲经济区以外地区以开展业务。此类转移将根据适用法律的要求并遵循适用的保障措施进行，例如，基于欧盟委员会就数据保护级别做出的充分性决定，或使用欧盟委员会批准的标准合同条款。</span
      >
    </p>
    <p class="p1"></p>
    <h4>
      <b>我们会存储您的数据多久？我们如何保护它？</b>
    </h4>
    <p>
      <span
        >一般而言，个人数据将保留至不再需要用于上述目的为止。如果我们有法定义务（例如根据会计法规）按照法定保留期限保留某些类型的数据，则保留期限可能会更长。此外，如果我们出于保护自身合法权益的合法利益而需要更长时间地保留任何信息，我们将根据诉讼时效保留为此目的所需的信息，或在适用的情况下，保留至相关索赔最终得到解决为止。</span
      >
    </p>
    <p>
      <span
        >我们实施技术和组织措施来维护您个人数据的安全。我们已建立物理、管理和技术安全措施，以确保您个人数据的安全性和保密性。只有工作需要的人员才能访问您的数据。</span
      >
    </p>
    <p class="p1"></p>
    <h4>
      <b>您的数据保护权利是什么？</b>
    </h4>
    <p>
      <span>根据适用法律并在其限制范围内，您拥有以下权利：</span>
    </p>
    <p class="p1"></p>
    <p>
      <i><span>访问您的个人数据的权利</span></i
      ><span>——您有权知道我们是否正在处理您的个人数据并访问它。</span>
    </p>
    <p>
      <i><span>更正您的个人数据的权利</span></i
      ><span>——如果您认为您的个人数据不准确或不完整，您可以要求更正。</span>
    </p>
    <p>
      <i><span>被遗忘权</span></i
      ><span>——在法律允许的范围内，您有权要求删除您的个人数据。</span>
    </p>
    <p>
      <i><span>限制处理的权利</span></i
      ><span>——在某些情况下，您有权要求限制对您的个人数据的处理。</span>
    </p>
    <p>
      <i><span>反对处理的权利</span></i
      ><span>——在某些情况下，您有权反对处理您的个人数据。</span>
    </p>
    <p>
      <i><span>撤回同意的权利</span></i
      ><span>——一旦您同意处理您的个人数据，您有权随时撤回。</span>
    </p>
    <p>
      <i><span>转移您的个人数据的权利</span></i
      ><span
        >——在法律适用的情况下，您有权以常用的、机器可读的格式将您提供的个人数据返还给您，或者在技术可行的情况下，将其转移给第三方。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span
        >如果您想行使这些权利中的任何一项，请使用本隐私声明末尾的联系信息与我们联系。请注意，其中一些权利并非绝对的，行使这些权利可能受到某些限制。</span
      >
    </p>
    <p class="p1"></p>
    <h4>
      <b>Swappie 隐私声明的变更</b>
    </h4>
    <p>
      <span
        >由于我们的处理流程或适用法律发生变化，我们可能会更新本隐私声明。届时，我们会在我们的网站上发布更新后的隐私声明。&nbsp;</span
      >
    </p>
    <h4>
      <b>联系信息</b>
    </h4>
    <p>
      <span
        >如果您对本隐私声明、我们持有的有关您的个人数据有任何疑问，或希望行使您的任何数据保护权利，请随时与我们联系。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <span>数据控制者的联系信息：</span>
    </p>
    <p>
      <span>名称: Swappie Oy</span>
    </p>
    <p>
      <span>公司ID：2692328-4</span>
    </p>
    <p>
      <span>地址: Itämerenkatu 3A, 00180 赫尔辛基, 芬兰</span>
    </p>
    <p>
      <span>电话号码 +358104063821</span>
    </p>
    <p>
      <span>电子邮件地址：privacy（at）swappie.com</span>
    </p>
    <p>
      <span>网站：www.swappie.com</span>
    </p>
    <p class="p1"></p>
    <p>
      <span
        >如果您想提出投诉，或者您认为 Swappie
        没有令人满意地解决您的问题，您可以联系您所在国家/地区的当地主管监督机构，或我们总部的监督机构——芬兰数据保护监察员。</span
      >
    </p>
    <p class="p1"></p>
    <p>
      <!-- OneTrust Cookies Settings button start --><br />
      <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie设置</button><br />
      <!-- OneTrust Cookies Settings button end --><br />
      <!-- OneTrust Cookies List start -->
    </p>
    <div id="ot-sdk-cookie-policy">
      <div id="ot-sdk-cookie-policy-v2" class="ot-sdk-cookie-policy ot-sdk-container">
        <h3 id="cookie-policy-title" class="ot-sdk-cookie-policy-title">Cookie 列表</h3>
        <div id="cookie-policy-description">
          Cookie
          是网站在用户访问时要求您的浏览器存储在您设备上的一小段数据（文本文件），用于记住您的相关信息，例如您的语言偏好或登录信息。这些
          Cookie 由我们设置，称为第一方 Cookie。我们还会使用第三方
          Cookie（即来自与您正在访问的网站域名不同的域名的
          Cookie）进行广告和营销活动。更具体地说，我们将 Cookie 和其他追踪技术用于以下目的：
        </div>

        <section>
          <h4 class="ot-sdk-cookie-policy-group">功能 Cookie</h4>
          <p class="ot-sdk-cookie-policy-group-desc">
            这些 Cookie
            允许提供增强功能和个性化内容，如视频和实时聊天。我们或我们已将其服务添加至我们页面上的第三方提供者可以进行设置。如果您不允许使用这些
            Cookie，则可能无法实现部分或全部功能的正常工作。
          </p>

          <table>
            <caption class="ot-scrn-rdr">
              功能 Cookie
            </caption>
            <thead>
              <tr>
                <th scope="col" class="ot-table-header ot-host">Cookie 子组</th>
                <th scope="col" class="ot-table-header ot-cookies">曲奇饼</th>
                <th scope="col" class="ot-table-header ot-cookies-type">使用的 Cookie</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">business.swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">i18next</td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">mamma-assets.swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  swappie-ab-以旧换新-高级电池、 swappie-ab-西班牙-基于价格的旅程产品页面、
                  swappie-ab-定价发现迭代、 swappie-ab-荷兰-丹麦以旧换新
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  swappie-ab-电池-通信-80-85、 cookie_consent_targeting、 ab.storage.sessionId.xxx、
                  cookie_consent_performance、
                  swappie-ab-xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx、
                  swappie_exp_DPMBRko1QMWjZboIk-B8hw、 swappie-ab-trade-in-de、
                  swappie_exp_Ter-SZ_iRRKv5zPvf0XntA、 swappie_exp_w1g9Cy7wTbKnjYFhZDnxfQ、
                  swappie-ab-trade-in-se、 swappie_exp_9_pDcA3gRdmikfNXccFmIw、
                  swappie_exp__fZxKTwCSwKbfp4igedYsw
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <h4 class="ot-sdk-cookie-policy-group">定向 Cookie</h4>
          <p class="ot-sdk-cookie-policy-group-desc">
            这些 Cookie 由广告合作伙伴通过我们的网站进行设置。这些公司可能利用 Cookie
            构建您的兴趣分布图并向您展示其他网站上的相关广告。它们只需识别您的浏览器和设备便可发挥作用。如果您不允许使用这些
            Cookie，您将不能体验不同网站上的定向广告。
          </p>

          <table>
            <caption class="ot-scrn-rdr">
              定向 Cookie
            </caption>
            <thead>
              <tr>
                <th scope="col" class="ot-table-header ot-host">Cookie 子组</th>
                <th scope="col" class="ot-table-header ot-cookies">曲奇饼</th>
                <th scope="col" class="ot-table-header ot-cookies-type">使用的 Cookie</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">mamma-assets.swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">_dcmn_p</td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  __kla_id、 _scid、 ab._gd#############、 _tt_enable_cookie、 _gat_UA-XXXXXX-X、
                  _uetsid、 _rdt_uuid、 _fbp、 kk_leadtag、 criteo_write_test、 cto_tld_test、
                  cto_bundle、 _gcl_au、 _ttp、 ab.storage.deviceId.、 _pin_unauth、 _schn、
                  swappie_exp_mPS4vy3IS2CIC6mXm3Pkaw
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">doubleclick.net</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  ar_debug、IDE、接收 cookie 弃用、test_cookie
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">exchange.mediavine.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  criteo、mv_tokens、mv_tokens_eu-v1
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">tpmn.co.kr</td>
                <td class="ot-cookies-td" data-label="Cookies">criteo，uuid</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">bat.bing.com</td>
                <td class="ot-cookies-td" data-label="Cookies">先生</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">www.pinterest.ie</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  _pinterest_referrer、_pinterest_sess、_routing_id、csrftoken、_auth
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">www.youtube.com</td>
                <td class="ot-cookies-td" data-label="Cookies">测试 Cookie 已启用，下一个 ID</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">www.facebook.com</td>
                <td class="ot-cookies-td" data-label="Cookies"></td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">outbrain.com</td>
                <td class="ot-cookies-td" data-label="Cookies">obuid，criteo</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">static.klaviyo.com</td>
                <td class="ot-cookies-td" data-label="Cookies">__kla_id</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">static-tracking.klaviyo.com</td>
                <td class="ot-cookies-td" data-label="Cookies">__kla_id</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">snapchat.com</td>
                <td class="ot-cookies-td" data-label="Cookies">sc_at</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">youtube.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  YSC，同意，VISITOR_INFO1_LIVE，VISITOR_PRIVACY_METADATA
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">apple.com</td>
                <td class="ot-cookies-td" data-label="Cookies">地理</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">c.bing.com</td>
                <td class="ot-cookies-td" data-label="Cookies">SRM_B</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">必应</td>
                <td class="ot-cookies-td" data-label="Cookies">MUID、MSPTC</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">criteo.com</td>
                <td class="ot-cookies-td" data-label="Cookies">uid</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">抖音</td>
                <td class="ot-cookies-td" data-label="Cookies">_ttp</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">ct.pinterest.com</td>
                <td class="ot-cookies-td" data-label="Cookies">_pinterest_ct_ua</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">static.criteo.net</td>
                <td class="ot-cookies-td" data-label="Cookies">criteo_write_test</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">www.pinterest.com</td>
                <td class="ot-cookies-td" data-label="Cookies">_routing_id</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
            </tbody>
          </table>
        </section>
        <section>
          <h4 class="ot-sdk-cookie-policy-group">性能 Cookie</h4>
          <p class="ot-sdk-cookie-policy-group-desc">
            使用 Cookie，我们可以计算访问量和流量来源，以便衡量和提高我们网站的性能。 Cookie
            有助于我们了解哪些页面最受欢迎、哪些最不受欢迎，并查看访问者如何浏览网站。这些 Cookie
            收集的所有信息都聚合在一起，因此是匿名处理方式。如果您不允许使用这些
            Cookie，我们将不知道您何时访问了我们的网站。
          </p>

          <table>
            <caption class="ot-scrn-rdr">
              性能 Cookie
            </caption>
            <thead>
              <tr>
                <th scope="col" class="ot-table-header ot-host">Cookie 子组</th>
                <th scope="col" class="ot-table-header ot-cookies">曲奇饼</th>
                <th scope="col" class="ot-table-header ot-cookies-type">使用的 Cookie</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">mamma-assets.swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  _hjIncludedInPageviewSample、 _hjIncludedInSessionSample、 _clsk
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">swappie.com</td>
                <td class="ot-cookies-td" data-label="Cookies">
                  _ga_xxxxxxxxxx、 _hjSession_xxxxxx、 FPID、 _ga、 _clck、 _uetvid、 FPLC、 _gat_UA
                  -、 _hjAbsoluteSessionInProgress、 _gclxxxx、 _hjSessionUser_xxxxxx、 _dd_s、
                  _hjFirstSeen、 _ga_xxxxxxx、 _gid , _gat_gtag_xxxxxxxxxxxxxxxxxxxxxxxxxxx ,
                  _hjDonePolls
                </td>
                <td class="ot-cookies-type" data-label="Cookies used">第一方</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">script.hotjar.com</td>
                <td class="ot-cookies-td" data-label="Cookies">_hjIncludedInPageviewSample</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">
                  www.datadoghq-browser-agent.com
                </td>
                <td class="ot-cookies-td" data-label="Cookies">dd_cookie_test_，_dd_s</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
              <tr>
                <td class="ot-host-td" data-label="Cookie Subgroup">sc-static.net</td>
                <td class="ot-cookies-td" data-label="Cookies">X-AB</td>
                <td class="ot-cookies-type" data-label="Cookies used">第三者</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="less"></style>
